<template>
  <span v-if="tag == 'span'" @click="sort()" class="hand">
    <span class="mr-1">
      <i class="fas fa-sort" :class="icon"></i>
    </span>
    {{ text }}
  </span>
  <th v-else @click="sort()" scope="col" class="hand">
    <span class="mr-1">
      <i class="fas fa-sort" :class="icon"></i>
    </span>
    {{ text }}
  </th>
</template>

<script>
export default {
  props: ["field", "text", "request", "tag"],
  data() {
    return {};
  },
  computed: {
    icon() {
      const o = this.request.options.sort[this.field];
      return !o ? "fa-sort" : o == "asc" ? "fa-sort-alpha-down" : "fa-sort-alpha-up";
    },
  },

  methods: {
    sort() {
      let sort = "asc";
      let current = this.request.options.sort[this.field];
      if (!current) {
        sort = "asc";
      } else if (current == "asc") {
        sort = "desc";
      } else if ((current = "desc")) {
        sort = undefined;
      }
      this.request.options.sort = {
        ...this.request.options.sort,
        [this.field]: sort,
      };
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
th {
  cursor: pointer;
}
</style>
